<template>
  <div class="header" :class="{ 'header-fixed' : scrolled == true}">
    <div class="header-top">
      
      
      <div class="user-wrapper"  @mouseover="updateFrontVersionDB()">
        <vs-dropdown vs-custom-content vs-trigger-click color="#B20564">
          <a class="a-icon" href.prevent v-if="this.userProp">
            <img v-if="!this.userProp.avatar || !this.userProp.avatar.length" :src="require('../../assets/img/ico-man.svg')"/>
            <img v-if="this.userProp.avatar && !!this.userProp.avatar.length" :src="this.userProp.avatar"/>
            <p class="user-name" v-if="this.userProp.firstname && this.userProp.lastname">{{this.userProp.firstname}} {{this.userProp.lastname}}</p>
            <p class="user-name" v-if="!this.userProp.firstname || !this.userProp.lastname">{{$t('dash.header.myaccount')}}</p>
            <i class="fa-solid fa-caret-down"></i>
          </a>
          <vs-dropdown-menu class="loginx">
            <vs-dropdown-item @click="()=>{this.$router.push({ path: 'settings' })}" v-if="['Admin', 'Editor', 'Writter'].includes(getUserRole)">
              <div class="dropdown-item">
                <a>
                  <img
                    src="../../assets/img/header/nav/ico-gear.svg"
                    alt="settings"
                  >
                  <p>{{$t('dash.header.nav.settings')}} <span>{{ applicationVersion }} 
                    <Tooltip
                      v-if="checkVersion"
                      :text="$t('dash.header.nav.new_front_version') + checkVersion"
                      position="bottom"
                    >
                      <i class="material-icons">notifications</i>
                      &nbsp;
                    </Tooltip>
                  </span></p>
                </a>
              </div>
            </vs-dropdown-item>
            <vs-dropdown-item @click="()=>{this.$router.push({ path: 'settings/billing' })}" v-if="['Admin', 'Editor'].includes(getUserRole)">
              <div class="dropdown-item">
                <a>
                  <img
                    src="../../assets/img/header/nav/ico-invoice.svg"
                    alt="invoice"
                  >
                  
                  <p>{{$t('dash.header.nav.invoice')}}</p>
                </a>
              </div>
            </vs-dropdown-item>
            <vs-dropdown-item>
              <div class="dropdown-item">
                <a href="mailto:contact@mashup-web.com">
                  <img
                    src="../../assets/img/header/nav/ico-support.svg"
                    alt="support"
                  >
                  <p>{{$t('dash.header.nav.support')}}</p>
                </a>
              </div>
            </vs-dropdown-item>
            <vs-dropdown-item v-if="pwaInstalled && ['Admin', 'Editor', 'Writter'].includes(getUserRole)">
              <div class="dropdown-item">
                <a @click="installPwa">
                  <img
                    src="../../assets/img/header/nav/pwa-install.svg"
                    alt="application"
                  >
                  <p>{{$t('dash.header.nav.pwa')}}</p>
                </a>
              </div>
            </vs-dropdown-item>
            <vs-dropdown-item>
              <div class="dropdown-item">
                <a href="/#/legal" target="_blank">
                  <img
                    src="../../assets/img/legal-icon.svg"
                    alt="legal"
                  >
                  <p>{{$t('dash.header.nav.legal')}}</p>
                </a>
              </div>
            </vs-dropdown-item>
            <vs-dropdown-item @click="switchVersion()">
              <div class="dropdown-item">
                <a @click="logout">
                  <img src="../../assets/img/header/nav/arrow-left-right.svg" alt="logout">
                  <p>{{version == 'beta' ? $t('dash.header.nav.switchVersion.old') : $t('dash.header.nav.switchVersion.beta')}}</p>
                </a>
              </div>
            </vs-dropdown-item>
            <vs-dropdown-item @click="change('logout')">
              <div class="dropdown-item">
                <a @click="logout">
                  <img src="../../assets/img/header/nav/log-out.svg" alt="logout">
                  <p>{{$t('dash.header.nav.logout')}}</p>
                </a>
              </div>
            </vs-dropdown-item>
           
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>  
      <div class="add-post" :class="[{'pages-nav': isPagesNavSection}]" v-if="['Admin', 'Editor', 'Writter'].includes(getUserRole) && getUserPlan">
        <vs-button
          class="add-btn btn-large btn-img"
          color="#6a1f4c"
          @click="goToPost"
          vs-type="filled"
        >
          <p>{{$t('dash.posts.add')}}</p>
          <img src="../../assets/img/Add-icon.svg" alt="search">
        </vs-button>
      </div>
      <div class="logo-wrapper">
        <img class="logo" src="../../assets/img/logo_white.png" alt="Mashup logo">
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { EventBus } from '@/event-bus';
import Autocomplete from 'vuejs-auto-complete'
import Posts from '../mixins/Posts'
import User from '../mixins/User'
import Notif from '../mixins/Notif'
import { version } from "./../../../package.json"
import Tooltip from './tooltip/tooltipInit.vue'
import activeFrontV2 from './posts/mixins/activeFrontV2';

export default {
  name: 'component-header',

  components: {
    Autocomplete,
    Tooltip
  },
  

  mixins: [Posts, User, Notif, activeFrontV2],

  data() {
    return {
      locales: ['en', 'fr', 'de', 'es', 'pt', 'it'],
      source: [],
      window: {
        width: 0,
        height: 0
      },
      profile: {
        firstname: 'Matthieu',
        lastname: 'Gudefin'
      },
      pwaInstalled: null,
      applicationVersion: version,
      applicationVersionDB: null,
      version: localStorage.getItem('version_') === null ? 'beta' : localStorage.getItem('version_'),
    }
  },

  props: {
    scrolled: {
      type: Boolean,
      required: true
    },
    userProp: {
      type: Object
    },
    section: String
  },

  created() {
    this.profile.firstname = this.userProp.firstname
    this.profile.lastname = this.userProp.lastname  
    // if(localStorage.getItem('user'))
    //   this.saveLocale(JSON.parse(localStorage.getItem('user')).id, this.$i18n.locale)

    if(localStorage.getItem('front_version')) 
      this.applicationVersionDB = localStorage.getItem('front_version')

    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.pwaInstalled = e;
    })
    window.addEventListener('appinstalled', () => {
      this.pwaInstalled = null;
    })
  },

  computed: {
    checkVersion() {
      if(this.applicationVersionDB) {
        let frontVersion = this.applicationVersion.split('.').map(v => parseInt(v))
        let frontVersionDB = this.applicationVersionDB.split('.').map(v => parseInt(v))
  
        if(this.applicationVersion != this.applicationVersionDB && frontVersionDB.some((db,index) => db > frontVersion[index])) {
          return this.applicationVersionDB
        }
      }
      return null
    },

    getUserRole() {
      if(!this.userProp) return null
      if(this.userProp.admin)
        return 'Admin'
      else
        return this.userProp.role && this.userProp.role.length
                    ? this.userProp.role[0]
                    : 'Editor'
      
    },

    isPagesNavSection(){
      return !(['overview', 'sources', 'settings', 'invoice', 'postcreator'].includes(this.section) || this.$route.name === 'postCreator')
    }
  },

  methods: {

    updateFrontVersionDB() {
      this.getFrontVersion().then(res => {
        const { success, front_version } = res.body
        if (!success || success !== true) return
        localStorage.setItem('front_version', front_version)
        this.applicationVersionDB = front_version
      })
    },

    async installPwa() {
      this.pwaInstalled.prompt()
      this.pwaInstalled.userChoice.then((choice) => {
        console.log(choice.outcome, choice)
        if (choice.outcome === 'accepted') {
          // Do something additional if the user chose to install
        } else {
          // Do something additional if the user declined
        }
      })
    },

    goToPost() {
      if (localStorage.version_ && localStorage.version_ == 'old') {
        localStorage.setItem('section', 'posts')
        if(['posts', 'planner'].includes(this.section)){
          this.$emit('clickAddPost')
        }
        else
          this.$router.push({
            name: 'planner',
            params: {
              newPost: true
            }
          })

      }else{
        localStorage.setItem('section', 'posts')
        this.$router.push({
          name: 'postCreator'
        });
      }

     
    },

    changeLocale(lang) {
      localStorage.setItem('language', lang)
      this.$i18n.locale = lang
      this.saveLocale(this.userProp.id, this.$i18n.locale)
    },
    /**
     * Change section on tab click
     */
    change(section) {
      this.$emit('dropdown-clicked', 0, section)
      // document.querySelector(`.vs-tooltip`).remove()
    },
    /**
     * Get data to autocomplete search bar
     */
    urlFunction(input) {
      return this.searchPosts(input, this.userProp.account)
    },

    /**
     * Retrieve the connected pages
     */
    getPages(){
      if(!localStorage.getItem('pages')) return false
      return !JSON.parse(localStorage.getItem('pages')).length 
    },

    /**
     * Retrieve selected autocomplete search result
     * @param {Object} obj - search result
     */
    setObjValue(obj) {
      this.$emit('search', obj.selectedObject)
    },
    /**
     * Format search results to display
     */
    formatDisplay(result) {
      let html = `<p class="date">${moment(result.published_at).format("DD/MM/YY h:mm")}</p>
              ${ result.enclosure ? `<img class="thumb" src="${result.enclosure}">` : `<p class="noimg"></p>` }   
              <p class="descr">"${result.title}"</p>`

      let icon = result.page.length ? 'icon_check_purple' : 'icon_wait_grey'
      let status = result.page.length ? 'posted' : 'inqueue'

      html += `<p class="status-icon"><img
                  src="${require('../../assets/img/'+icon+'.svg')}"
                  width=26
                ></p><p class="status-text">
                ${this.$t('dash.posts.status.'+status)}</p>`

      return html
    },

    logout() {},
  }
}
</script>